export const ACCOUNTANT_SETTINGS_ACTIVE_TAB_LOCAL_STORAGE_KEY = 'newApp_accountantSettingsActiveTab';
export const ACCOUNTS_TAB_LABEL = 'konta';
export const EXPENSES_MANAGEMENT_TAB_LABEL = 'wydatki';
export const COMPANY_MANAGEMENT_TAB_LABEL = 'firma';
export const DOMAIN_MANAGEMENT_TAB_LABEL = 'domeny';
export const BANKS_MANAGEMENT_TAB_LABEL = 'banki';
